import React, { Component } from "react";
import ReeValidate from 'ree-validate'
import { connect } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { getPaymentToken } from "../store/actions/payments";
import { signUpFollower } from "../store/actions/auth";
import { injectStripe } from 'react-stripe-elements';
import { showAlert } from '../store/actions/alert';
import {convertReadbleFormat} from './../helpers';
import { COLORS } from './../styles/colors';
import Card from './card'

const $ = window.$;

class FollowMeNewUserModal extends Component {

    constructor(props){
        super(props)
        this.validator = new ReeValidate({
          email: 'required|email',
          password: 'required|min:3',
          confirmPassword: 'required'
        })
        this.state = {
          formData: {
            email: '',
            password: '',
            confirmPassword: ''
          },
          formErrors: this.validator.errors,
          isSubmit: false,
          isRevealPwd: false,
          isRevealConPwd: false
        }
    }

    componentDidMount() {
        const { errors } = this.validator
        const { removeError } = this.props
        $('#enroll').on('hidden.bs.modal', () => {
          this.setState({
            formData: {
                email: '',
                password: '',
                confirmPassword: ''
            },
            isRevealPwd: false,
            isRevealConPwd: false
          }, () => {
            errors.clear();
            removeError();
          });
        })
    }

    handleSubmit = e => {
        e.preventDefault()
        const { removeError } = this.props
        removeError();
        const { formData, confirmPassErr } = this.state
        const { errors } = this.validator
        if (!confirmPassErr) {
          this.validator.validateAll(formData)
            .then(success => {
              if (success) {
                this.createNonce(formData);
              } else {
                this.setState({ formErrors: errors })
              }
            })
        }
    }

    toggleVisiblePassword(isConfirmPassword) {
      if (isConfirmPassword) {
        this.setState({
          isRevealConPwd: !this.state.isRevealConPwd
        })
      } else {
        this.setState({
          isRevealPwd: !this.state.isRevealPwd
        })
      }
    }

    async createNonce(formData) {

        const { signUpFollower, showAlert, match: { params: { referralCode }} } = this.props;
        signUpFollower({
          ...formData,
          referenceCode: referralCode,
          type: 'basic'
        }).then((response) => {
            $('#enroll').modal('hide');
            this.props.showSuccessMessage();
            this.setState({
              isSubmit: false,
            });
        }).catch(error =>{
        this.setState({
          isSubmit: false,
        });
      });
    }

    handleChange = e => {
      const name = e.target.name
      const value = e.target.value
      const { errors } = this.validator
      errors.remove(name)
      this.setState({ formData: { ...this.state.formData, [name]: value } }, () => {
        this.validateConfirmPassword();
      })
      this.validator.validate(name, value)
        .then(() => {
          this.setState({ formErrors: errors })
        })
    }

    validateConfirmPassword() {
      const { password, confirmPassword } = this.state.formData;
      let confirmPassErr = '';
      if (password && confirmPassword && password !== confirmPassword) {
        confirmPassErr = 'Confirm password does not match';
      }
      this.setState({ confirmPassErr });
    }

   render() {
    const { formData, formErrors, isSubmit, isRevealPwd, isRevealConPwd, confirmPassErr } = this.state
    const { errors, planName } = this.props
    return (
        <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal">&times;</button>
                <h3>I need to enroll in Fitbanx.</h3>
                </div>
                <div style={{'padding':'50px'}} className="modal-body">
                <div className="row">
                  {errors && errors.message && <div className="alert alert-danger">{errors.message}</div>}
                  <form onSubmit={this.handleSubmit} noValidate>
                        <div className="form-group">
                          <label htmlFor="email">Log in email:</label>
                          <input type="email"
                              className="form-control"
                              id="email"
                              placeholder="Enter email"
                              name="email"
                              onChange={this.handleChange}
                              required
                              value={formData.email}/>
                          { formErrors.has('email') &&
                          <span className="error text-danger">{ convertReadbleFormat(formErrors.first('email')) }</span>
                          }
                    </div>
                    <div className="form-group" style={{
                      position: 'relative'
                    }}>
                      <label htmlFor="lname">Password:</label>
                      <input
                            type={isRevealPwd ? "text" : "password"}
                            className="form-control"
                            id="password"
                            name="password"
                            placeholder="Enter password"
                            onChange={this.handleChange}
                            required
                            value={formData.password}
                          />
                      <FontAwesomeIcon icon={ isRevealPwd ? faEyeSlash : faEye} title={'toggle'}
								          style={{
                            marginRight: '5px',
                            position: 'absolute',
                            right: '10px',
                            top: '48px',
                            color: COLORS.orange,
                            zIndex: '99999'
                          }}
                          onClick = {() => this.toggleVisiblePassword(false)} 
                      />
                      { formErrors.has('password') &&
                          <span className="error text-danger">{ convertReadbleFormat(formErrors.first('password')) }</span>
                      }
                  </div>

                  <div className="form-group" style={{
                      position: 'relative'
                    }}>
                      <label htmlFor="lname">Confirm Password:</label>
                      <input
                            type={isRevealConPwd ? "text" : "password"}
                            className="form-control"
                            id="confirmPassword"
                            name="confirmPassword"
                            placeholder="Enter password"
                            onChange={this.handleChange}
                            required
                            value={formData.confirmPassword}
                          />
                      <FontAwesomeIcon icon={ isRevealConPwd ? faEyeSlash : faEye} title={'toggle'}
								          style={{
                            marginRight: '5px',
                            position: 'absolute',
                            right: '10px',
                            top: '48px',
                            color: COLORS.orange,
                            zIndex: '99999'
                          }}
                          onClick = {() => this.toggleVisiblePassword(true)} 
                      />
                      { (formErrors.has('confirmPassword') || confirmPassErr) &&
                          <span className="error text-danger">
                            {(formErrors.has('confirmPassword') &&
                          convertReadbleFormat(formErrors.first('confirmPassword')))
                          || confirmPassErr}
                          </span>
                      }
                  </div>
                
                  
                  <div className="row">
                      <div className="col-md-12">
                      <button type="submit"  style={{ 'width': '100%' }}  className="btn circle btn-light border btn-md" disabled={isSubmit}>Finish</button>
                  </div>
                  </div>
                  </form>
                </div>
                </div>
                <div className="modal-footer">
                <button type="button"  className="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
            </div>

    )
  }
}

function mapStateToProps(state, ownProps) {
    return {
      paymentToken: state.payments.token
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      getPaymentToken: () => {
        return dispatch(getPaymentToken());
      },
      signUpFollower: (data) => {
        return dispatch(signUpFollower(data));
      },
      showAlert: (message, isError) => {
        return dispatch(showAlert(message, isError));
      }
    }
  }

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(injectStripe(FollowMeNewUserModal));



// WEBPACK FOOTER //
// ./src/modals/followMeNewUser.js